import { Message } from '@/types'

interface FallbackIndicatorProps {
  message: Message
}

export function FallbackIndicator({ message }: FallbackIndicatorProps) {
  if (!message.isFallback || !message.fallback_reason) {
    return null
  }

  // Extract error type from fallback reason
  const errorType = message.fallback_reason.includes('rate_limit')
    ? 'rate_limit'
    : message.fallback_reason.includes('timeout')
    ? 'timeout'
    : message.fallback_reason.includes('network')
    ? 'network'
    : 'general'

  const getIcon = () => {
    switch (errorType) {
      case 'rate_limit':
        return '⚠️'
      case 'timeout':
        return '⏱️'
      case 'network':
        return '📡'
      default:
        return '⚠️'
    }
  }

  const getMessage = () => {
    switch (errorType) {
      case 'rate_limit':
        return 'High volume detected'
      case 'timeout':
        return 'Response delayed'
      case 'network':
        return 'Connection issue'
      default:
        return 'Technical issue'
    }
  }

  return (
    <div className="mb-2 flex items-center gap-2 rounded-lg bg-amber-50 px-3 py-2 text-xs text-amber-800 dark:bg-amber-900/20 dark:text-amber-200">
      <span>{getIcon()}</span>
      <span className="font-medium">{getMessage()}</span>
      <span className="text-amber-600 dark:text-amber-300">
        - Connecting you with our team
      </span>
    </div>
  )
}
